/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Mulai_LinkInputs */

const en_serve_mulai_link = /** @type {(inputs: Serve_Mulai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Have a Claude or ChatGPT subscription? Build on your own computer →`)
};

const id_serve_mulai_link = /** @type {(inputs: Serve_Mulai_LinkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punya langganan Claude atau ChatGPT? Bangun di komputermu sendiri →`)
};

/**
* | output |
* | --- |
* | "Have a Claude or ChatGPT subscription? Build on your own computer →" |
*
* @param {Serve_Mulai_LinkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_mulai_link = /** @type {((inputs?: Serve_Mulai_LinkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Mulai_LinkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_mulai_link(inputs)
	return en_serve_mulai_link(inputs)
});